import aa from 'search-insights';
import { useGlobalContentStore } from '~/store/globalContent';

export default function useAlgoliaInsights() {
  const browserTrackingCookie = useCookie('randomId', { maxAge: 3600 * 24 * 365 });
  const globalContent = useGlobalContentStore();

  const trackProductClick = (
    objectID: string,
    position: number,
    queryID?: string,
    indexName?: string
  ) => {
    const userToken = browserTrackingCookie.value || '';
    const index = indexName || globalContent.getAlgoliaIndex;

    const payload = {
      userToken,
      eventName: 'Product Clicked',
      index,
      objectIDs: [objectID],
      positions: [position],
    } as any;

    if (queryID && queryID !== '') {
      payload.queryID = queryID;
      aa('clickedObjectIDsAfterSearch', payload);
    } else {
      aa('clickedObjectIDs', payload);
    }
  };

  const trackProductView = (
    objectID: string,
    indexName?: string
  ) => {
    const userToken = browserTrackingCookie.value || '';
    const index = indexName || globalContent.getAlgoliaIndex;
    const queryID = localStorage.getItem('queryID') || '';

    const payload = {
      userToken,
      eventName: 'Product Viewed',
      index,
      objectIDs: [objectID],
    } as any;

    if (queryID && queryID !== '') {
      payload.queryID = queryID;
    }

    aa('viewedObjectIDs', payload);
  };

  return {
    trackProductClick,
    trackProductView,
  };
}
